import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Alert, Box } from "@mui/material";
import * as React from "react";

import { useAuth } from "@/providers";
import { SelectionButton } from "@/shared/components";
import { FileSystemNode, FileSystemNodeType } from "@/shared/domain/files";

import { DatasetTopicTable } from "./DatasetTopicTable";

interface DatasetTopicsProps {
  datasetId: string;
}

export function DatasetTopics({ datasetId }: DatasetTopicsProps) {
  const { currentOrganization } = useAuth();

  const [selectedFileIds, setSelectedFileIds] = React.useState<Set<string>>(
    new Set(),
  );

  const handleFileSelectionChange = (fileId: string, checked: boolean) => {
    setSelectedFileIds((prev) => {
      const next = new Set(prev);
      if (checked) {
        next.add(fileId);
      } else {
        next.delete(fileId);
      }
      return next;
    });
  };

  const selectedItems: FileSystemNode[] = React.useMemo(
    () =>
      Array.from(selectedFileIds).map((fileId) => ({
        name: fileId,
        type: FileSystemNodeType.File,
        file: {
          file_id: fileId,
          relative_path: "",
          association_id: undefined,
        },
      })),
    [selectedFileIds],
  );

  const handleDeselectAll = () => {
    setSelectedFileIds(new Set());
  };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          marginBottom: 2,
          alignItems: "center",
          height: "50px",
        }}
      >
        {selectedFileIds.size > 0 ? (
          <SelectionButton
            selectedItems={selectedItems}
            currentOrganization={currentOrganization}
            handleDeselectAll={handleDeselectAll}
          />
        ) : (
          <Alert
            severity="info"
            sx={{ width: "100%" }}
            icon={<InfoOutlinedIcon />}
          >
            This tab shows an aggregated view of topics derived from all files
            in the dataset. Expand topics to see their associated source files.
          </Alert>
        )}
      </Box>
      <DatasetTopicTable
        datasetId={datasetId}
        selectedFileIds={selectedFileIds}
        onFileSelectionChange={handleFileSelectionChange}
      />
    </div>
  );
}
